import CopyModal from "./CopyModal";
import EmailModal from "./EmailModal";
import LinkedinModal from "./LinkedinModal";

export default function ShareModals() {
  return (
    <>
      <LinkedinModal />
      <CopyModal />
      <EmailModal />
    </>
  );
}
